import { announce } from "./liveAnnouncer";
import { Localize as AriaLocalize } from "../../../shared/ariaLabelLocalize";

export const getResultCountMessage = (count, { langId, hasMore = false } = {}) => {
    const t = AriaLocalize[langId] || AriaLocalize["en_US"];
    if (count === 0) return t.no_results_found;
    if (count === 1 && !hasMore) return t.one_result_found;
    return (hasMore ? t.results_found_at_least : t.results_found).replace("{n}", count);
};

export const announceResultCount = (count, options = {}) => {
    announce(getResultCountMessage(count, options));
};
